import { gql } from 'graphql-request';

export const GetTrailData = gql`
  query GetTrailData($id: ID!) {
    trailData(id: $id) {
      id
      name
      gpxFile
      length
      elevationGain
      geolocLat
      geolocLng
    }
  }
`;
